import { HomeCampaignsFinishingSoonController } from './home-campaigns-finishing-soon.controller.js'

function homeCampaignsFinishingSoon () {
  return {
    restrict: 'E',
    templateUrl: '/home/directives/home-campaigns-finishing-soon/home-campaigns-finishing-soon-directive.html?$$REVISION$$',
    controller: HomeCampaignsFinishingSoonController
  }
}

export { homeCampaignsFinishingSoon }
